import { SelectInputOption } from 'src/components/UI/CustomUI/atoms/SelectInput/types'
import { getOptionsFromArray, getOptionsFromArrayMultiple } from 'src/helpers'
import storeInfo from '../store'
import { ContractorItem } from '../types'

export const getContractors = (): ContractorItem[] => {
  const { contractors } = storeInfo.store.getState()
  return contractors.items
}


export const getContractorSelected = (): ContractorItem | null => {
  const { contractors } = storeInfo.store.getState()
  return contractors.contractor || null
}


export const getAllContractors = (): ContractorItem[] => {
  const { contractors } = storeInfo.store.getState()
  return contractors.allItems
}

export const getTotalContractorsCount = (): number => {
  const { contractors } = storeInfo.store.getState()
  return contractors.total
}

export const getContractorsForDropdown = (): SelectInputOption[] => {
  const { contractors } = storeInfo.store.getState()
  const flattenedData = getOptionsFromArray(contractors.items, { key: 'affiliateId', label: 'name' }, { key: 'all', label: 'All Affiliates' })
  return flattenedData
}

export const getContractorsForDropdownWithoutAll = (): SelectInputOption[] => {
  const { contractors } = storeInfo.store.getState()
  const flattenedData = getOptionsFromArray(contractors.items, { key: 'affiliateId', label: 'name' })
  return flattenedData
}

export const getContractorsForMultipleField = (): SelectInputOption[] => {
  const { contractors } = storeInfo.store.getState()
  const flattenedData = getOptionsFromArrayMultiple(contractors.items, { key: 'id', label: 'name' })
  return flattenedData
}

export const getAllContractorsForMultipleField = (): SelectInputOption[] => {
  const { contractors } = storeInfo.store.getState()
  const flattenedData = getOptionsFromArrayMultiple(contractors.allItems, { key: 'id', label: 'name' })
  return flattenedData
}

export const getContractorsMultipleField = (): SelectInputOption[] => {
  const { contractors } = storeInfo.store.getState()
  const flattenedData = getOptionsFromArrayMultiple(contractors.items, { key: 'affiliateId', label: 'name' }, { key: 'all', label: 'All Affiliates', id: 'ALL_AFF' })
  return flattenedData
}

export const getAllContractorsForMultipleFieldWithoutAllOption = (): SelectInputOption[] => {
  const { contractors } = storeInfo.store.getState()
  const flattenedData = getOptionsFromArrayMultiple(contractors.items, { key: 'affiliateId', label: 'name' })
  return flattenedData.sort((a, b) => a.label.localeCompare(b.label))
}

export const getContractorById = (id: string): string => {
  const { contractors } = storeInfo.store.getState()
  return contractors.items.find(contractor => contractor.id === id)?.name || ''
}
